import React from 'react';
import { useTranslation } from '../../i18n';
import CognitiveAbilitiesSummary from './CognitiveAbilitiesSummary/CognitiveAbilitiesSummary';
import {
    CultureFitScores,
    InterviewScores,
    MentalTestScores,
    ScoresAvailability,
} from '../../typings';
import styles from './styles.module.css';
import CultureFitSummary from './CultureFitSummary';
import ReportPage from '../../ReportPage/ReportPage';
import SpeakingSummary from './SpeakingSummary';

interface SummaryProps {
    companyName: string;
    expectedScores: ScoresAvailability;
    cultureFitScores?: CultureFitScores;
    interviewScores?: InterviewScores;
    mentalTestScores?: MentalTestScores;
    videoRecordingOptedOut: boolean;
    hasBaseline: boolean;
    userRole: 'candidate' | 'recruiter';
    candidateName: string;
    reportsDate: string;
}

const Summary = (props: SummaryProps) => {
    const {
        companyName,
        expectedScores,
        cultureFitScores,
        interviewScores,
        mentalTestScores,
        hasBaseline,
        userRole,
        videoRecordingOptedOut,
    } = props;
    const { t } = useTranslation();

    const isCultureFitExpected =
        expectedScores.cultureFit.companyEngagement ||
        expectedScores.cultureFit.cultureMatch ||
        expectedScores.cultureFit.workPreferences;
    const isSpeakingExpected =
        expectedScores.speaking.motivation ||
        expectedScores.speaking.confidence;
    const isCognitiveAbilitiesExpected =
        expectedScores.cognitiveAbilities.stressResilience ||
        expectedScores.cognitiveAbilities.ease ||
        expectedScores.cognitiveAbilities.categories;

    return (
        <>
            {isCultureFitExpected && (
                <ReportPage isSummaryPage={true}>
                    <div className={styles.summary}>
                        <h1 className="no_spacing_below">
                            {t('SUMMARY_PAGE.TITLE')}
                        </h1>
                        <CultureFitSummary
                            userRole={userRole}
                            companyName={companyName}
                            videoRecordingOptedOut={videoRecordingOptedOut}
                            expectedCultureFitScores={expectedScores.cultureFit}
                            cultureFitScores={cultureFitScores}
                            hasBaseline={hasBaseline}
                        />
                    </div>
                </ReportPage>
            )}
            {(isSpeakingExpected || isCognitiveAbilitiesExpected) && (
                <ReportPage isSummaryPage={true}>
                    <div className={styles.summary}>
                        {!isCultureFitExpected && (
                            <h1 className="no_spacing_below">
                                {t('SUMMARY_PAGE.TITLE')}
                            </h1>
                        )}
                        {isSpeakingExpected && !videoRecordingOptedOut && (
                            <SpeakingSummary
                                speakingScores={interviewScores}
                                userRole={userRole}
                            />
                        )}
                        {isCognitiveAbilitiesExpected && (
                            <CognitiveAbilitiesSummary
                                videoRecordingOptedOut={videoRecordingOptedOut}
                                mentalTestScores={mentalTestScores}
                                userRole={userRole}
                                companyName={companyName}
                            />
                        )}
                    </div>
                </ReportPage>
            )}
        </>
    );
};

export default Summary;
